module.exports = __webpack_public_path__ + "media/images/sort_desc_disabled-d7dc10c7.png";